import {remCalc} from '../../_utils'

export default {
    baseStyle: () => ({
        pageContainer: {
            w: '100%',
            flexDirection: 'column',
            paddingTop: {base: remCalc(16), md: remCalc(24), lg: remCalc(40), xl: remCalc(80)},
            paddingBottom: {base: remCalc(24), md: remCalc(80)},
            paddingInline: {base: remCalc(16), md: remCalc(24)},
            maxW: remCalc(1400),
            mx: 'auto',
        },
        pageTitle: {
            textStyle: {base: 'head-large', lg: 'head-xlarge'},
            fontWeight: 'medium',
            paddingY: {base: remCalc(16), lg: remCalc(24)},
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            marginBottom: {base: remCalc(24), lg: remCalc(40)},
            w: '100%',
        },
        cardsGrid: {
            display: 'grid',
            gridTemplateColumns: {base: '1fr', lg: 'repeat(2, 1fr)'},
            gap: {base: remCalc(16), lg: remCalc(24)},
            w: '100%',
            alignItems: 'start',
        },
        card: {
            flexDirection: 'column',
            padding: remCalc(24),
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            borderRadius: ['large.base', 'large.sm', 'large.md', 'large.lg'],
        },
        cardTitle: {
            textStyle: {base: 'head-xsmall', lg: 'head-medium'},
            fontWeight: 'medium',
            marginBottom: remCalc(8),
        },
        cardDescription: {
            textStyle: 'body-medium',
            marginBottom: remCalc(24),
        },
        searchButton: {
            maxW: {base: '100%', lg: remCalc(332)},
            h: remCalc(40),
            w: '100%',
        },

        // Label
        '.chakra-form__label': {
            lineHeight: '150%',
            marginTop: remCalc(12),
            marginBottom: '0',
        },

        // Input fields
        'input[type="text"]': {
            borderColor: 'border.dark !important',
            _hover: {borderColor: 'border.dark !important'},
            _focus: {borderColor: 'border.dark !important', boxShadow: 'none !important'},
            _focusVisible: {borderColor: 'border.dark !important', boxShadow: 'none !important'},
        },
        'input[aria-invalid="true"]': {
            borderColor: 'text.danger !important',
            _hover: {borderColor: 'text.danger !important'},
            _focus: {borderColor: 'text.danger !important'},
            _focusVisible: {borderColor: 'text.danger !important'},
        },
        '.chakra-input__group:has(input[aria-invalid="true"]) .chakra-form__label': {
            color: 'text.danger !important',
        },

        // Floating label
        'input:not(:placeholder-shown) ~ .chakra-form__label': {
            backgroundColor: 'background.default',
            fontSize: `${remCalc(10)} !important`,
            lineHeight: `${remCalc(12)} !important`,
            paddingLeft: `${remCalc(0)} !important`,
            paddingRight: `${remCalc(4)} !important`,
            transform: 'translateY(calc(50% - 26px)) !important',
            transformOrigin: 'left top',
        },
        '.chakra-input__group:focus-within .chakra-form__label': {
            backgroundColor: 'background.default',
            fontSize: `${remCalc(10)} !important`,
            lineHeight: `${remCalc(12)} !important`,
            paddingLeft: `${remCalc(0)} !important`,
            paddingRight: `${remCalc(4)} !important`,
            transform: 'translateY(calc(50% - 26px)) !important',
            transformOrigin: 'left top',
            color: 'border.dark !important',
        },
        'input:not(:placeholder-shown) ~ .chakra-form__label::before, .chakra-input__group:focus-within .chakra-form__label::before':
            {
                display: 'none !important',
            },

        // Error message
        '.chakra-form__error-message': {
            color: 'text.danger',
            textStyle: 'body-xxsmall',
            mt: 'xxsmall.md',
            textAlign: 'left',
        },

        // Results modal
        resultsModalOverlay: {
            background: 'background.overlay-modal',
        },
        resultsModalContent: {
            background: 'background.default',
            maxW: {base: '100%', md: remCalc(688), lg: remCalc(900)},
            borderTopLeftRadius: remCalc(8),
            borderTopRightRadius: remCalc(8),
            borderBottomLeftRadius: {base: remCalc(0), md: remCalc(8)},
            borderBottomRightRadius: {base: remCalc(0), md: remCalc(8)},
            p: ['xsmall.md', 'xsmall.md', 'xsmall.md', 'xsmall.lg'],
        },
        resultsModalHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '0 0 16px 0',
        },
        resultsModalTitle: {
            textStyle: 'body-medium',
            color: 'text.default',
            fontWeight: 'normal',
            textAlign: 'left',
        },
        resultsCloseIcon: {
            cursor: 'pointer',
            boxSize: {base: 'iconsSize.medium', lg: 'iconsSize.large'},
            ml: remCalc(16),
            flexShrink: 0,
        },
        resultsLoginAlert: {
            mb: remCalc(16),
            textAlign: 'left',
            flexShrink: 0,
        },
        resultsModalBody: {
            p: 0,
            borderTop: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
        },
        resultsTableWrapper: {
            w: '100%',
            overflow: 'visible',
        },

        resultsTable: {
            display: {base: 'flex', md: 'grid'},
            flexDirection: {base: 'column', md: 'initial'},
            gridTemplateColumns: {
                md: 'auto minmax(0, 1fr) minmax(0, 1.5fr) minmax(0, 2fr) auto',
            },
            rowGap: {base: remCalc(16), md: 0},
            w: '100%',
            minW: {md: remCalc(640)},
        },
        resultsTableHeadRow: {
            display: {base: 'none', md: 'contents'},
        },
        resultsHeadCell: {
            textStyle: 'body-small',
            fontWeight: 'medium',
            color: 'text.subdued',
            py: remCalc(12),
            px: remCalc(8),
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            position: {md: 'sticky'},
            top: 0,
            background: 'background.default',
            zIndex: 1,
        },
        resultsTableRow: {
            display: {base: 'flex', md: 'contents'},
            flexDirection: {base: 'column', md: 'initial'},
            gap: {base: remCalc(8), md: 0},
            p: {base: remCalc(16), md: 0},
            border: {base: 'small', md: 'none'},
            borderStyle: {base: 'solid', md: 'initial'},
            borderColor: {base: 'border.light', md: 'initial'},
            borderRadius: {base: remCalc(8), md: 0},
        },
        resultsCell: {
            display: 'flex',
            flexDirection: {base: 'row', md: 'column'},
            justifyContent: {base: 'space-between', md: 'center'},
            alignItems: {base: 'center', md: 'flex-start'},
            gap: {base: remCalc(16), md: 0},
            py: {base: 0, md: remCalc(16)},
            px: {base: 0, md: remCalc(8)},
            borderBottom: {base: 'none', md: 'small'},
            borderStyle: {md: 'solid'},
            borderColor: {md: 'border.light'},
            minW: 0,
        },
        resultsCellLabel: {
            display: {base: 'block', md: 'none'},
            textStyle: 'body-small',
            fontWeight: 'medium',
            color: 'text.subdued',
            flexShrink: 0,
        },
        resultsCellValue: {
            textStyle: 'body-small',
            fontWeight: 'normal',
            color: 'text.default',
            wordBreak: 'break-word',
            textAlign: {base: 'right', md: 'left'},
        },
        loginOnBehalfButton: {
            h: remCalc(40),
            w: {base: '100%', md: 'auto'},
            minW: {md: remCalc(140)},
        },
    }),
}
